"use strict";

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

exports.renderPlainText = function (text) {
  return text.split('\n').map(function (part, key, parts) {
    return react_1["default"].createElement(react_1["default"].Fragment, {
      key: key
    }, part, key + 1 < parts.length ? react_1["default"].createElement("br", null) : react_1["default"].createElement(react_1["default"].Fragment, null));
  });
};